/**
 * MessageBoard関連の定数
 */

// 画像添付の最大枚数
export const MAX_IMAGE_ATTACHMENTS = 3

export const FREE_THEME_ID = 1
